export const flagsPosition: any = {
  AC: 'bg-[0px_0px] h-[10px]',
  AD: 'bg-[-22px_0px] h-[14px]',
  AE: 'bg-[-44px_0px] h-[10px]',
  AF: 'bg-[-66px_0px] h-[14px]',
  AG: 'bg-[-88px_0px] h-[14px]',
  AI: 'bg-[-110px_0px] h-[14px]',
  AL: 'bg-[-132px_0px] h-[15px]',
  AM: 'bg-[-154px_0px] h-[10px]',
  AO: 'bg-[-176px_0px] h-[14px]',
  AQ: 'bg-[-198px_0px] h-[14px]',
  AR: 'bg-[-220px_0px] h-[13px]',
  AS: 'bg-[-242px_0px] h-[10px]',
  AT: 'bg-[-264px_0px] h-[14px]',
  AU: 'bg-[-286px_0px] h-[10px]',
  AW: 'bg-[-308px_0px] h-[14px]',
  AX: 'bg-[-330px_0px] h-[13px]',
  AZ: 'bg-[-352px_0px] h-[10px]',
  BA: 'bg-[-374px_0px] h-[14px]',
  BB: 'bg-[-396px_0px] h-[14px]',
  BD: 'bg-[-418px_0px] h-[12px]',
  BE: 'bg-[-440px_0px] h-[15px] w-[20px]',
  BF: 'bg-[-460px_0px] h-[14px]',
  BG: 'bg-[-482px_0px] h-[12px]',
  BH: 'bg-[-504px_0px] h-[12px]',
  BI: 'bg-[-526px_0px] h-[12px]',
  BJ: 'bg-[-548px_0px] h-[14px]',
  BL: 'bg-[-570px_0px] h-[14px]',
  BM: 'bg-[-592px_0px] h-[14px]',
  BN: 'bg-[-614px_0px] h-[10px]',
  BO: 'bg-[-636px_0px] h-[14px]',
  BQ: 'bg-[-658px_0px] h-[14px]',
  BR: 'bg-[-680px_0px] h-[14px]',
  BS: 'bg-[-702px_0px] h-[10px]',
  BT: 'bg-[-724px_0px] h-[14px]',
  BV: 'bg-[-746px_0px] h-[15px]',
  BW: 'bg-[-768px_0px] h-[14px]',
  BY: 'bg-[-790px_0px] h-[10px]',
  BZ: 'bg-[-812px_0px] h-[14px]',
  CA: 'bg-[-834px_0px] h-[12px]',
  CC: 'bg-[-856px_0px] h-[10px]',
  CD: 'bg-[-878px_0px] h-[15px]',
  CF: 'bg-[-900px_0px] h-[14px]',
  CG: 'bg-[-922px_0px] h-[14px]',
  CH: 'bg-[-944px_0px] h-[14px] w-[15px]',
  CI: 'bg-[-961px_0px] h-[14px]',
  CK: 'bg-[-983px_0px] h-[10px]',
  CL: 'bg-[-1005px_0px] h-[14px]',
  CM: 'bg-[-1027px_0px] h-[14px]',
  CN: 'bg-[-1049px_0px] h-[14px]',
  CO: 'bg-[-1071px_0px] h-[14px]',
  CP: 'bg-[-1093px_0px] h-[14px]',
  CR: 'bg-[-1115px_0px] h-[12px]',
  CU: 'bg-[-1137px_0px] h-[10px]',
  CV: 'bg-[-1159px_0px] h-[12px]',
  CW: 'bg-[-1181px_0px] h-[14px]',
  CX: 'bg-[-1203px_0px] h-[10px]',
  CY: 'bg-[-1225px_0px] h-[14px]',
  CZ: 'bg-[-1247px_0px] h-[14px]',
  DE: 'bg-[-1269px_0px] h-[12px]',
  DG: 'bg-[-1291px_0px] h-[10px]',
  DJ: 'bg-[-1313px_0px] h-[14px]',
  DK: 'bg-[-1335px_0px] h-[15px]',
  DM: 'bg-[-1357px_0px] h-[10px]',
  DO: 'bg-[-1379px_0px] h-[14px]',
  DZ: 'bg-[-1401px_0px] h-[14px]',
  EA: 'bg-[-1423px_0px] h-[14px]',
  EC: 'bg-[-1445px_0px] h-[14px]',
  EE: 'bg-[-1467px_0px] h-[13px]',
  EG: 'bg-[-1489px_0px] h-[14px]',
  EH: 'bg-[-1511px_0px] h-[10px]',
  ER: 'bg-[-1533px_0px] h-[10px]',
  ES: 'bg-[-1555px_0px] h-[14px]',
  ET: 'bg-[-1577px_0px] h-[10px]',
  EU: 'bg-[-1599px_0px] h-[14px]',
  FI: 'bg-[-1621px_0px] h-[12px]',
  FJ: 'bg-[-1643px_0px] h-[10px]',
  FK: 'bg-[-1665px_0px] h-[10px]',
  FM: 'bg-[-1687px_0px] h-[11px]',
  FO: 'bg-[-1709px_0px] h-[15px]',
  FR: 'bg-[-1731px_0px] h-[14px]',
  GA: 'bg-[-1753px_0px] h-[15px]',
  GB: 'bg-[-1775px_0px] h-[10px]',
  GD: 'bg-[-1797px_0px] h-[12px]',
  GE: 'bg-[-1819px_0px] h-[14px]',
  GF: 'bg-[-1841px_0px] h-[14px]',
  GG: 'bg-[-1863px_0px] h-[14px]',
  GH: 'bg-[-1885px_0px] h-[14px]',
  GI: 'bg-[-1907px_0px] h-[10px]',
  GL: 'bg-[-1929px_0px] h-[14px]',
  GM: 'bg-[-1951px_0px] h-[14px]',
  GN: 'bg-[-1973px_0px] h-[14px]',
  GP: 'bg-[-1995px_0px] h-[14px]',
  GQ: 'bg-[-2017px_0px] h-[14px]',
  GR: 'bg-[-2039px_0px] h-[14px]',
  GS: 'bg-[-2061px_0px] h-[10px]',
  GT: 'bg-[-2083px_0px] h-[13px]',
  GU: 'bg-[-2105px_0px] h-[11px]',
  GW: 'bg-[-2127px_0px] h-[10px]',
  GY: 'bg-[-2149px_0px] h-[12px]',
  HK: 'bg-[-2171px_0px] h-[14px]',
  HM: 'bg-[-2193px_0px] h-[10px]',
  HN: 'bg-[-2215px_0px] h-[14px]',
  HR: 'bg-[-2237px_0px] h-[10px]',
  HT: 'bg-[-2259px_0px] h-[12px]',
  HU: 'bg-[-2281px_0px] h-[10px]',
  IC: 'bg-[-2303px_0px] h-[14px]',
  ID: 'bg-[-2325px_0px] h-[14px]',
  IE: 'bg-[-2347px_0px] h-[10px]',
  IL: 'bg-[-2369px_0px] h-[15px]',
  IM: 'bg-[-2391px_0px] h-[10px]',
  IN: 'bg-[-2413px_0px] h-[14px]',
  IO: 'bg-[-2435px_0px] h-[10px]',
  IQ: 'bg-[-2457px_0px] h-[14px]',
  IR: 'bg-[-2479px_0px] h-[12px]',
  IS: 'bg-[-2501px_0px] h-[15px]',
  IT: 'bg-[-2523px_0px] h-[14px]',
  JE: 'bg-[-2545px_0px] h-[14px]',
  JM: 'bg-[-2567px_0px] h-[10px]',
  JO: 'bg-[-2589px_0px] h-[10px]',
  JP: 'bg-[-2611px_0px] h-[14px]',
  KE: 'bg-[-2633px_0px] h-[14px]',
  KG: 'bg-[-2655px_0px] h-[12px]',
  KH: 'bg-[-2677px_0px] h-[13px]',
  KI: 'bg-[-2699px_0px] h-[10px]',
  KM: 'bg-[-2721px_0px] h-[12px]',
  KN: 'bg-[-2743px_0px] h-[14px]',
  KP: 'bg-[-2765px_0px] h-[10px]',
  KR: 'bg-[-2787px_0px] h-[14px]',
  KW: 'bg-[-2809px_0px] h-[10px]',
  KY: 'bg-[-2831px_0px] h-[10px]',
  KZ: 'bg-[-2853px_0px] h-[10px]',
  LA: 'bg-[-2875px_0px] h-[14px]',
  LB: 'bg-[-2897px_0px] h-[14px]',
  LC: 'bg-[-2919px_0px] h-[10px]',
  LI: 'bg-[-2941px_0px] h-[12px]',
  LK: 'bg-[-2963px_0px] h-[14px]',
  LR: 'bg-[-2985px_0px] h-[11px]',
  LS: 'bg-[-3007px_0px] h-[14px]',
  LT: 'bg-[-3029px_0px] h-[12px]',
  LU: 'bg-[-3051px_0px] h-[12px]',
  LV: 'bg-[-3073px_0px] h-[10px]',
  LY: 'bg-[-3095px_0px] h-[10px]',
  MA: 'bg-[-3117px_0px] h-[14px]',
  MC: 'bg-[-3139px_0px] h-[15px] w-[19px]',
  MD: 'bg-[-3160px_0px] h-[10px]',
  ME: 'bg-[-3182px_0px] h-[10px]',
  MF: 'bg-[-3204px_0px] h-[14px]',
  MG: 'bg-[-3226px_0px] h-[14px]',
  MH: 'bg-[-3248px_0px] h-[11px]',
  MK: 'bg-[-3270px_0px] h-[10px]',
  ML: 'bg-[-3292px_0px] h-[14px]',
  MM: 'bg-[-3314px_0px] h-[14px]',
  MN: 'bg-[-3336px_0px] h-[10px]',
  MO: 'bg-[-3358px_0px] h-[14px]',
  MP: 'bg-[-3380px_0px] h-[10px]',
  MQ: 'bg-[-3402px_0px] h-[14px]',
  MR: 'bg-[-3424px_0px] h-[14px]',
  MS: 'bg-[-3446px_0px] h-[10px]',
  MT: 'bg-[-3468px_0px] h-[14px]',
  MU: 'bg-[-3490px_0px] h-[14px]',
  MV: 'bg-[-3512px_0px] h-[14px]',
  MW: 'bg-[-3534px_0px] h-[14px]',
  MX: 'bg-[-3556px_0px] h-[12px]',
  MY: 'bg-[-3578px_0px] h-[10px]',
  MZ: 'bg-[-3600px_0px] h-[14px]',
  NA: 'bg-[-3622px_0px] h-[14px]',
  NC: 'bg-[-3644px_0px] h-[10px]',
  NE: 'bg-[-3666px_0px] h-[15px] w-[18px]',
  NF: 'bg-[-3686px_0px] h-[10px]',
  NG: 'bg-[-3708px_0px] h-[10px]',
  NI: 'bg-[-3730px_0px] h-[12px]',
  NL: 'bg-[-3752px_0px] h-[14px]',
  NO: 'bg-[-3774px_0px] h-[15px]',
  NP: 'bg-[-3796px_0px] h-[15px] w-[13px]',
  NR: 'bg-[-3811px_0px] h-[10px]',
  NU: 'bg-[-3833px_0px] h-[10px]',
  NZ: 'bg-[-3855px_0px] h-[10px]',
  OM: 'bg-[-3877px_0px] h-[10px]',
  PA: 'bg-[-3899px_0px] h-[14px]',
  PE: 'bg-[-3921px_0px] h-[14px]',
  PF: 'bg-[-3943px_0px] h-[14px]',
  PG: 'bg-[-3965px_0px] h-[15px]',
  PH: 'bg-[-3987px_0px] h-[10px]',
  PK: 'bg-[-4009px_0px] h-[14px]',
  PL: 'bg-[-4031px_0px] h-[13px]',
  PM: 'bg-[-4053px_0px] h-[14px]',
  PN: 'bg-[-4075px_0px] h-[10px]',
  PR: 'bg-[-4097px_0px] h-[14px]',
  PS: 'bg-[-4119px_0px] h-[10px]',
  PT: 'bg-[-4141px_0px] h-[14px]',
  PW: 'bg-[-4163px_0px] h-[13px]',
  PY: 'bg-[-4185px_0px] h-[11px]',
  QA: 'bg-[-4207px_0px] h-[8px]',
  RE: 'bg-[-4229px_0px] h-[14px]',
  RO: 'bg-[-4251px_0px] h-[14px]',
  RS: 'bg-[-4273px_0px] h-[10px]',
  RU: 'bg-[-4295px_0px] h-[14px]',
  RW: 'bg-[-4317px_0px] h-[14px]',
  SA: 'bg-[-4339px_0px] h-[14px]',
  SB: 'bg-[-4361px_0px] h-[10px]',
  SC: 'bg-[-4383px_0px] h-[10px]',
  SD: 'bg-[-4405px_0px] h-[10px]',
  SE: 'bg-[-4427px_0px] h-[13px]',
  SG: 'bg-[-4449px_0px] h-[14px]',
  SH: 'bg-[-4471px_0px] h-[10px]',
  SI: 'bg-[-4493px_0px] h-[10px]',
  SJ: 'bg-[-4515px_0px] h-[15px]',
  SK: 'bg-[-4537px_0px] h-[14px]',
  SL: 'bg-[-4559px_0px] h-[14px]',
  SM: 'bg-[-4581px_0px] h-[15px]',
  SN: 'bg-[-4603px_0px] h-[14px]',
  SO: 'bg-[-4625px_0px] h-[14px]',
  SR: 'bg-[-4647px_0px] h-[14px]',
  SS: 'bg-[-4669px_0px] h-[10px]',
  ST: 'bg-[-4691px_0px] h-[10px]',
  SV: 'bg-[-4713px_0px] h-[12px]',
  SX: 'bg-[-4735px_0px] h-[14px]',
  SY: 'bg-[-4757px_0px] h-[14px]',
  SZ: 'bg-[-4779px_0px] h-[14px]',
  TA: 'bg-[-4801px_0px] h-[10px]',
  TC: 'bg-[-4823px_0px] h-[10px]',
  TD: 'bg-[-4845px_0px] h-[14px]',
  TF: 'bg-[-4867px_0px] h-[14px]',
  TG: 'bg-[-4889px_0px] h-[13px]',
  TH: 'bg-[-4911px_0px] h-[14px]',
  TJ: 'bg-[-4933px_0px] h-[10px]',
  TK: 'bg-[-4955px_0px] h-[10px]',
  TL: 'bg-[-4977px_0px] h-[10px]',
  TM: 'bg-[-4999px_0px] h-[14px]',
  TN: 'bg-[-5021px_0px] h-[14px]',
  TO: 'bg-[-5043px_0px] h-[10px]',
  TR: 'bg-[-5065px_0px] h-[14px]',
  TT: 'bg-[-5087px_0px] h-[12px]',
  TV: 'bg-[-5109px_0px] h-[10px]',
  TW: 'bg-[-5131px_0px] h-[14px]',
  TZ: 'bg-[-5153px_0px] h-[14px]',
  UA: 'bg-[-5175px_0px] h-[14px]',
  UG: 'bg-[-5197px_0px] h-[14px]',
  UM: 'bg-[-5219px_0px] h-[11px]',
  UN: 'bg-[-5241px_0px] h-[14px]',
  US: 'bg-[-5263px_0px] h-[11px]',
  UY: 'bg-[-5285px_0px] h-[14px]',
  UZ: 'bg-[-5307px_0px] h-[10px]',
  VA: 'bg-[-5329px_0px] h-[15px] w-[15px]',
  VC: 'bg-[-5346px_0px] h-[14px]',
  VE: 'bg-[-5368px_0px] h-[14px]',
  VG: 'bg-[-5390px_0px] h-[10px]',
  VI: 'bg-[-5412px_0px] h-[14px]',
  VN: 'bg-[-5434px_0px] h-[14px]',
  VU: 'bg-[-5456px_0px] h-[12px]',
  WF: 'bg-[-5478px_0px] h-[14px]',
  WS: 'bg-[-5500px_0px] h-[10px]',
  XK: 'bg-[-5522px_0px] h-[15px]',
  YE: 'bg-[-5544px_0px] h-[14px]',
  YT: 'bg-[-5566px_0px] h-[14px]',
  ZA: 'bg-[-5588px_0px] h-[14px]',
  ZM: 'bg-[-5610px_0px] h-[14px]',
  ZW: 'bg-[-5632px_0px] h-[10px]',
};
